import {AddSchema} from "mobx-graphlink";
import {TriggerSet} from "../@TriggerSet.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";
import {Phase} from "../../@Shared/Phase.js";

export class EngineConfig_Background {
	constructor(initialData: Partial<EngineConfig_Background>) { Object.assign(this, initialData); }

	enabled: boolean;
	increaseVolume_triggerSet: TriggerSet;
	increaseVolume_amount: number; // 0-1
	decreaseVolume_triggerSet: TriggerSet;
	decreaseVolume_amount: number; // 0-1

	effect?: EffectPointer;
	startVolume: number; // 0-1

	effectsBaseEnabledUnless_microSnoozeActive: boolean;
	effectsBaseEnabledUnless_mediaCompPlaying: boolean;
	effectsBaseEnabledUnless_inPhases: Phase[];
}
AddSchema("EngineConfig_Background", {
	properties: {
		enabled: {type: "boolean"},
		increaseVolume_triggerSet: {$ref: "TriggerSet"},
		increaseVolume_amount: {type: "number"},
		decreaseVolume_triggerSet: {$ref: "TriggerSet"},
		decreaseVolume_amount: {type: "number"},

		effect: {$ref: "EffectPointer"},
		startVolume: {type: "number"},

		effectsBaseEnabledUnless_microSnoozeActive: {type: "boolean"},
		effectsBaseEnabledUnless_mediaCompPlaying: {type: "boolean"},
		effectsBaseEnabledUnless_inPhases: {type: "array", items: {$ref: "Phase"}},
	},
});